export const SignInWithEmailMetrics = {
    View: 'View SignInWithMetrics Component',
    ClickContinue: 'Click Continue Button',
    ClickTextbox: 'Click Email Textbox',
    ViewErrorMessage: 'View Error Message',
};

export const SocialLoginErrorCodes = {
    SocialLoginNonPatient: 8,
    SocialLoginOther: 9,
    SocialLoginRequestExpired: 10,
    SocialLoginCannotBeLinkedForMfaUsers: 12,
};
